<template>
  <div class="bask-page">
    <div class="header-bg">
      <div class="header">
        <div class="blue">
          <div class="avatar">
            <img class="img" src="../../../../assets/avatar.jpg" alt="" />
            <div class="name">大连梦之队</div>
          </div>
          <div class="score">113</div>
        </div>
        <div class="chessboard">
          <div class="title"><span>小组赛</span><span>第一轮</span><span>07月01日 10:00</span></div>
          <div class="status">
            <div class="btn">已结束</div>
          </div>
          <div class="row">
            <div class="row-1">Q1</div>
            <div class="row-2">Q2</div>
            <div class="row-3">Q3</div>
            <div class="row-4">Q4</div>
          </div>
          <div class="row">
            <div class="row-1">53</div>
            <div class="row-2">25</div>
            <div class="row-3">15</div>
            <div class="row-4">63</div>
          </div>
          <div class="row">
            <div class="row-1">12</div>
            <div class="row-2">51</div>
            <div class="row-3">23</div>
            <div class="row-4">51</div>
          </div>
        </div>
        <div class="red">
          <div class="score">103</div>
          <div class="avatar">
            <img class="img" src="../../../../assets/avatar.jpg" alt="" />
            <div class="name">众智篮球队</div>
          </div>
        </div>
      </div>
    </div>
    <div class="team-tab">
      <div class="tab-list">
        <div class="tab-item" v-for="(item, index) in tabList" :key="index" @click="handleTab(item, index)">
          <div class="name">{{ item.name }}</div>
          <div class="line" v-show="tabIndex == index"></div>
        </div>
      </div>
    </div>
    <component :is="component"></component>
  </div>
</template>

<script>
import BasketballTeamData from './BasketballTeamData.vue'
import BasketballPlayerData from './BasketballPlayerData.vue'
import BasketballPrefecture from './BasketballPrefecture.vue'
export default {
  name: 'BasketballTeamDetail',
  props: {},
  data() {
    return {
      tabList: [{ name: '球队数据' }, { name: '球员数据' }, { name: '投篮热区' }],
      tabIndex: 0,
      component: 'BasketballTeamData',
    }
  },
  components: {BasketballTeamData,BasketballPlayerData,BasketballPrefecture},
  mounted() {},
  methods: {
    handleTab(item, index) {
      this.tabIndex = index
      switch (index) {
        case 0:
          this.component = 'BasketballTeamData'
          break
        case 1:
          this.component = 'BasketballPlayerData'
          break
        case 2:
          this.component = 'BasketballPrefecture'
          break
        default:
          this.component = 'BasketballTeamData'
          break
      }
    },
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.bask-page {
  width: 100%;
  background-color: #f8f8f8;
  box-sizing: border-box;
  .header-bg {
    width: 100%;
    height: 300px;
    background-image: url('../../../../../comm/assets/match/basketball_team.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding-top: 100px;
    .header {
      width: 1200px;
      margin: 0 auto;
      padding-top: 60px;
      margin-top: border-box;
      height: 100%;
      padding: 0 100px;
      display: flex;
      justify-content: space-between;
      .blue {
        width: 300px;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        .avatar {
          width: 120px;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          text-align: center;
          .img {
            width: 120px;
            height: 120px;
            border-radius: 20px;
          }
          .name {
            color: #fff;
            font-size: 22px;
            margin-top: 20px;
          }
        }
        .score {
          font-size: 40px;
          color: #fff;
          margin-top: 30px;
          margin-left: 30px;
        }
      }
      .chessboard {
        width: 300px;
        height: 100%;
        margin: 0 50px;
        .title {
          font-size: 14px;
          font-weight: bold;
          color: #fff;
          display: flex;
          justify-content: space-between;
          span {
            height: 40px;
            line-height: 40px;
          }
          span:nth-child(1) {
            display: inline-block;
            width: 30%;
          }
          span:nth-child(2) {
            display: inline-block;
            width: 30%;
          }
          span:last-child {
            display: inline-block;
            width: 40%;
            overflow: hidden;
          }
        }
        .status {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 10px;
          .btn {
            width: 100px;
            height: 30px;
            line-height: 30px;
            border-radius: 15px;
            background-color: #c4c4c4;
            color: #ffffff;
            text-align: center;
            cursor: pointer;
          }
          .btn:hover {
            opacity: 0.8;
          }
        }
        .row {
          color: #fff;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .row-1 {
            text-align: center;
            height: 30px;
            line-height: 30px;
          }
          .row-2 {
            height: 30px;
            line-height: 30px;
            text-align: center;
          }
          .row-3 {
            text-align: center;
            height: 30px;
            line-height: 30px;
          }
          .row-4 {
            text-align: center;
            height: 30px;
            line-height: 30px;
          }
        }
      }
      .red {
        width: 300px;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        .avatar {
          width: 120px;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          text-align: center;
          .img {
            width: 120px;
            height: 120px;
            border-radius: 20px;
          }
          .name {
            color: #fff;
            font-size: 22px;
            margin-top: 20px;
          }
        }
        .score {
          font-size: 40px;
          color: #fff;
          margin-top: 30px;
          margin-right: 30px;
        }
      }
    }
  }
  .team-tab {
    width: 100%;
    height: 70px;
    border-bottom: 1px solid #ccc;
    .tab-list {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .tab-item {
        margin-right: 80px;
        // margin-top: 10px;
        height: 34px;
        cursor: pointer;

        .name {
          font-size: 16px;
          font-weight: bold;
          padding-bottom: 5px;
        }
        .line {
          height: 4px;
          background-color: #aa1f23;
          width: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/basketball/components/BasketballTeamDetail.vue